import { useCallback } from 'react';
import { showToast } from '../../utils/toast';
import { listingsService } from '../../api';

// Mirrors mobile Step 2 (sell.tsx Step 2): description, doors, seats, features.
export const useEquipmentHandler = () => {
  const handleNext = useCallback(
    async (formData: Record<string, any>): Promise<boolean> => {
      const params = new URLSearchParams(window.location.search);
      const id = params.get('id') || undefined;

      if (!id) {
        showToast.error('Save Step 1 first');
        return false;
      }

      const payload = {
        id,
        step: 2,
        mode: 'update' as const,
        data: {
          description: formData.description || undefined,
          features: Array.isArray(formData.features) ? formData.features : [],
          doors: formData.doors ? Number(formData.doors) : undefined,
          seats: formData.seats ? Number(formData.seats) : undefined,
        },
      };

      try {
        await listingsService.upsertStep(payload);
        showToast.success('Equipment saved');
        return true;
      } catch (err) {
        console.error('[LISTING][STEP 2] failed', err);
        showToast.error('Failed to save equipment');
        return false;
      }
    },
    []
  );

  const handleBack = useCallback(() => true, []);

  return { handleNext, handleBack };
};
